module.exports = __webpack_public_path__ + "img/ohlook.8fefb567.png";